export { default as details } from './Detail/Detail'
export { default as scheduleList } from './Schedule/Schedule'
export { default as home } from './Programs/Programs'
export { default as programsDetail } from './ProgramsDetail/ProgramsDetail'
export { default as me } from './Profile/Me'
export { default as studentList } from './StudentList/StudentList'
export { default as filmfest } from './FilmFest/FilmFest'
export { default as studentDetail } from './StudentDetail/StudentDetail'
export { default as splash } from './Splash/Splash'



// WEBPACK FOOTER //
// ./src/components/RouteIndex.js